import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { RetencionAplicada } from 'src/app/model/commission-hold-release.model';
import * as XLSX from 'xlsx';

@Component({
    selector: 'app-retenciones-tabla',
    templateUrl: './retenciones-tabla.component.html',
    styleUrls: ['./retenciones-tabla.component.css']
})
export class RetencionesTablaComponent implements OnChanges {

    @Input() retencionesRaiz: RetencionAplicada[] = [];

    // Paginación
    paginaActual = 1;
    elementosPorPagina = 10;
    opcionesElementos = [10, 25, 50, 100];

    // Búsqueda
    textoBusqueda = '';
    listaFiltrada: RetencionAplicada[] = [];

    statusOptions = [
        { value: 'PPR', label: 'Pendiente por Retener' },
        { value: 'RT', label: 'Retenido' },
        { value: 'PPL', label: 'Pendiente por Liberar' },
        { value: 'LB', label: 'Liberado' }
    ];

    ngOnChanges() {
        this.paginaActual = 1;
        this.filtrar();
    }

    filtrar() {
        const texto = this.textoBusqueda.toLowerCase().trim();
        if (!texto) {
            this.listaFiltrada = [...this.retencionesRaiz];
        } else {
            this.listaFiltrada = this.retencionesRaiz.filter(raiz =>
                Object.values(raiz).some(val =>
                    val !== null && val !== undefined &&
                    val.toString().toLowerCase().includes(texto)
                )
            );
        }
        this.paginaActual = 1;
    }

    toggleRow(row: RetencionAplicada) {
        row.expanded = !row.expanded;
    }

    get totalElementos(): number { return this.listaFiltrada.length; }

    get totalPaginas(): number {
        return Math.ceil(this.totalElementos / this.elementosPorPagina);
    }

    get paginaActualData(): RetencionAplicada[] {
        const inicio = (this.paginaActual - 1) * this.elementosPorPagina;
        return this.listaFiltrada.slice(inicio, inicio + this.elementosPorPagina);
    }

    get paginas(): number[] {
        const rango = 2;
        const paginas: number[] = [];
        for (let i = Math.max(1, this.paginaActual - rango);
            i <= Math.min(this.totalPaginas, this.paginaActual + rango); i++) {
            paginas.push(i);
        }
        return paginas;
    }

    get mostrandoDesde(): number {
        return this.totalElementos === 0 ? 0 : (this.paginaActual - 1) * this.elementosPorPagina + 1;
    }

    get mostrandoHasta(): number {
        return Math.min(this.paginaActual * this.elementosPorPagina, this.totalElementos);
    }

    irAPagina(pagina: number) {
        if (pagina >= 1 && pagina <= this.totalPaginas) this.paginaActual = pagina;
    }

    cambiarElementosPorPagina(valor: number) {
        this.elementosPorPagina = Number(valor);
        this.paginaActual = 1;
        this.filtrar();
    }

    getStatusClass(estatus: string): string {
        switch (estatus) {
            case 'PPR': return 'badge badge-info';
            case 'PPL': return 'badge badge-warning';
            case 'RT': return 'badge badge-success';
            case 'LB': return 'badge badge-primary';
            default: return 'badge badge-secondary';
        }
    }

    getStatusDescription(estatus: string): string {
        return this.statusOptions.find(o => o.value === estatus).label || estatus;
    }

    exportarExcel() {
        const ws_data: any[][] = [];
        const headers = ['Id Asesor', 'Id Crédito', 'Monto Capital', 'Monto Comisión',
            'Monto Retenido', 'Extra', 'Estatus', 'Fecha Generación'];
        ws_data.push(headers);

        this.listaFiltrada.forEach(raiz => {
            ws_data.push([
                raiz.idAsesor, raiz.idCredit, raiz.capital, raiz.comision,
                raiz.montoRetenido, raiz.montoExcedenteExtra,
                raiz.estatus, this.formatFecha(raiz.fechaCreacionAplicado)  // ← formateado
            ]);
            (raiz.children || []).forEach(hijo => {
                ws_data.push([
                    hijo.idAsesor, hijo.idCredit, hijo.capital, hijo.comision,
                    hijo.montoRetenido, hijo.montoExcedenteExtra,
                    hijo.estatus, this.formatFecha(hijo.fechaCreacionAplicado)  // ← formateado
                ]);
            });
        });

        const wb = XLSX.utils.book_new();
        const ws = XLSX.utils.aoa_to_sheet(ws_data);
        ws['!cols'] = headers.map(h => ({ wch: Math.max(h.length, 15) }));
        XLSX.utils.book_append_sheet(wb, ws, 'Retenciones');
        XLSX.writeFile(wb, 'Reporte_Retenciones.xlsx');
    }

    formatFecha(fecha: string): string {
        if (!fecha) return '';
        return fecha.split('T')[0]; // Toma solo la parte yyyy-MM-dd
    }
}